// Textos de los errores del API (WS-2311). Ver api-errors/es.ts.
export const locale = {
  lang: 'en',
  data: {
    API_ERRORS: {
      AND_MORE: '{{message}} (and {{count}} more)',

      TYPE: {
        resource_not_found: 'The requested resource was not found.',
        action_unauthorized: 'You do not have permission to perform this action.',
        internal_error: 'Something went wrong. Please try again in a few minutes.',
        save_failed: 'We could not save it. Please try again in a few minutes.',
        load_failed: 'We could not load the data. Please try again in a few minutes.',
        headquarters_already_exists: 'The company already has a headquarters.',
        delete_failed: 'We could not delete it. Please try again in a few minutes.',
        upstream_unavailable: 'The service is unavailable right now. Please try again later.',

        // Flotas de taxi/VTC (docs/flotas-drivers/api-contract.md)
        fleet_onboarding_incomplete: 'Some sign-up steps are still missing.',
        legal_texts_outdated: 'The legal texts have changed. Review and accept them again.',
        membership_not_pending: 'This request is no longer pending. Reload the list.',
        vehicle_plate_taken: 'This number plate is already registered in a fleet.',
        shifts_locked: 'To assign shifts you need at least one vehicle and one accepted driver.',
        shifts_outdated: 'Someone changed the shifts while you were editing them. Reload them.',
        shift_conflict: 'There are shift conflicts. Check the highlighted cells.',
        member_already_exists: 'This person is already on the team.',
        last_owner: 'The fleet must have at least one owner.',
        document_already_reviewed: 'Someone else has already reviewed this document. Reload the queue.',
        billing_not_in_review: 'The billing details are no longer pending review. Reload the profile.',

        account_banned: 'The account is blocked. Contact support to reactivate it.',
        already_decided: 'This payout was already approved or rejected. Reload the page.',
        already_has_matches: 'The routine already has matches and cannot be changed.',
        birth_date_required: 'The user’s date of birth is missing; it is needed to open their payout account.',
        campaign_not_cancellable: 'The campaign is already closed and cannot be cancelled.',
        card_already_canceled: 'The card is cancelled and can no longer be changed.',
        card_generation_disabled: 'Card issuing is turned off right now.',
        card_not_eligible_not_in_driver_program: 'The user is not in the driver programme, so no card applies.',
        card_not_eligible_pilot_restricted: 'The card is in a pilot and this user is not part of it.',
        card_not_found: 'The user has no driver card.',
        card_not_issued_yet: 'The card has not been issued yet.',
        conflict: 'Another change was saved at the same time. Reload and try again.',
        coupon_already_applied: 'The user has already applied this coupon.',
        coupon_expired: 'The coupon has expired.',
        coupon_not_active_yet: 'The coupon is not active yet.',
        coupon_not_eligible: 'The coupon does not apply to this user.',
        coupon_not_found: 'We could not find the coupon.',
        date_overlap: 'The routine’s dates and times overlap with another of the user’s routines.',
        document_already_in_use: 'This ID document is already linked to another account.',
        document_data_unreadable: 'The scanned document could not be read.',
        document_mismatch: 'The driving licence details do not match the ID document.',
        document_not_scanned: 'The driving licence was not read. It needs to be scanned again.',
        document_verification_required: 'The ID document must be verified before adding a bank account.',
        empty_segment: 'The segment has no available recipients.',
        face_verification_already_completed: 'This face verification has already finished.',
        face_verification_already_passed: 'The user has already passed face verification for this trip.',
        face_verification_not_required: 'This user does not need face verification.',
        face_verification_provider_unavailable: 'The face verification service is not responding. Please try again later.',
        face_verification_required: 'Face verification must be passed before finishing the trip.',
        feature_locked: 'This section is not included in the company’s plan.',
        field_not_editable: 'This field cannot be edited.',
        group_not_cancellable: 'The group has no active campaign to cancel.',
        iban_already_registered: 'This IBAN is already registered on the account.',
        identity_data_missing: 'Verified identity details are missing to compare the document.',
        identity_document_mismatch: 'The scanned document is not the same as the one on the account.',
        identity_mismatch: 'The document details do not match the account.',
        import_already_running: 'A POI import is already running. Wait for it to finish before starting another.',
        insufficient_balance: 'There is not enough balance for this operation.',
        invalid_category: 'The driving licence does not include category B.',
        invalid_status: 'The driving licence verification was not completed.',
        label_not_applicable_to_pooling_route: 'This label cannot be assigned to trips.',
        label_not_applicable_to_user: 'This label cannot be assigned to users.',
        last_default_bank_account: 'This is the only bank account: add another before deleting it.',
        license_data_unreadable: 'Not all driving licence details could be read.',
        matricula_max_users: 'This number plate already has the maximum number of users.',
        negative_balance_blocked: 'The account has a negative balance and is blocked until it is settled.',
        no_payment_method: 'The company has no card on file.',
        not_pausable: 'Only recurring routines can be paused.',
        overlap: 'The routine overlaps with another of the user’s routines.',
        payment_in_progress: 'The payout is being paid right now. Reload in a few minutes.',
        payout_failed: 'The money could not be withdrawn. Please try again.',
        payout_recording_failed: 'The payment went through but could not be recorded. Do not retry: contact support.',
        pmst_disabled: 'The company has turned off the PMST.',
        polyline_unavailable: 'The trip route could not be calculated. Please try again.',
        recipient_not_cancellable: 'This recipient’s incentive is no longer pending.',
        reference_selfie_missing: 'There is no reference selfie: identity must be verified first.',
        route_not_active: 'The trip is neither pending nor in progress.',
        route_not_driver: 'This trip belongs to a passenger and has no price breakdown.',
        routine_limit_reached: 'The user has reached the maximum number of active routines.',
        routine_not_flexible: 'This option is only available for flexible routines.',
        seat_limit_reached: 'The company plan has no seats left.',
        stripe_account_not_created: 'There is no payout account yet: it is created when the first bank account is added.',
        stripe_connect_id_missing: 'The company has no payout account set up.',
        trial_locked: 'Your company trial has ended. Complete your account in Plan to keep using the dashboard.',
        user_profile_not_verified: 'Identity must be verified before withdrawing balance.',
        vehicle_overlap: 'The vehicle is already in another routine on the same dates and times.',
        user_whitelisted: 'The user is on the fraud whitelist: remove them from it before applying enhanced verification.',
        week_has_matches: 'That week already has matches and cannot be replanned.',
        without_cost_distance_exceeded: 'The free trip exceeds the maximum allowed distance.',
        without_cost_not_allowed: 'This user cannot create free trips.',
        // Catálogo de eventos del backoffice (trips-core)
        event_category_base: "This category can't be deleted. You can deactivate it.",
        event_category_in_use: "A category with events can't be deleted. You can deactivate it.",
        event_has_linked_routines: "The event's date, time and location can't be changed: it has trips that haven't departed yet.",
        event_has_trips: "An event with trips can't be deleted. Cancel it instead.",
        ticketmaster_not_configured: "The Ticketmaster lookup isn't set up on the server.",
        ticketmaster_unavailable: "Ticketmaster can't be reached right now. Try again in a few minutes.",
        football_data_not_configured: "The football-data lookup isn't set up on the server.",
        football_data_unavailable: "football-data can't be reached right now. Try again in a few minutes.",
        football_data_no_category: 'There is no active football or sport category for the matches.',
      },

      AUTH: {
        AUTH_CREDENTIAL_MISSING: 'Authentication is required to access this resource.',
        AUTH_CREDENTIAL_FORMAT_INVALID: 'The access credential format is invalid.',
        AUTH_CREDENTIAL_INTEGRITY_INVALID: 'The access credential is not valid.',
        AUTH_SESSION_EXPIRED_X0001: 'Your session has expired. Please sign in again.',
        AUTH_SESSION_EXPIRED_X0002: 'Your session has expired. Please sign in again.',
        AUTH_SESSION_EXPIRED_X0003: 'Your session has expired. Please sign in again.',
        AUTH_SESSION_REFERENCE_MISSING: 'The session could not be identified.',
        AUTH_SESSION_NOT_FOUND: 'The session is no longer available.',
        AUTH_SESSION_REVOKED: 'The session is no longer active. Please sign in again.',
        AUTH_IDENTITY_NOT_FOUND: 'The identity associated with the session is not available.',
        AUTH_APPLICATION_NOT_ALLOWED: 'The access application is not allowed.',
        AUTH_ACCESS_CONTEXT_MISMATCH: 'The access context is not valid for this resource.',
        AUTH_CREDENTIAL_REJECTED: 'The access credential was rejected.',
        AUTH_REQUIRED: 'Authentication is required to access this resource.',
        AUTH_PERMISSION_DENIED: 'You do not have permission to access this resource.',
        AUTH_BACKOFFICE_PERMISSION_DENIED: 'You do not have permission to access the backoffice.',
        AUTH_CHANNEL_REQUIRED: 'Authentication is required for this channel.',
        AUTH_CHANNEL_PERMISSION_DENIED: 'You do not have sufficient permissions for this channel.',
        AUTH_TEMPORARILY_UNAVAILABLE: 'The authentication service is temporarily unavailable.',
        AUTH_INTERNAL_ERROR: 'Access validation could not be completed.',
      },

      FIELD: {
        name: 'name',
        surname: 'surname',
        email: 'email',
        password: 'password',
        phone: 'phone',
        code: 'code',
        label: 'label',
      },

      RULE: {
        accepted: 'The {{field}} field must be accepted.',
        after: 'The {{field}} field must be a date after {{p0}}.',
        after_or_equal: 'The {{field}} field must be a date after or equal to {{p0}}.',
        alpha: 'The {{field}} field may only contain letters.',
        alpha_dash: 'The {{field}} field may only contain letters, numbers, dashes and underscores.',
        alpha_num: 'The {{field}} field may only contain letters and numbers.',
        array: 'The {{field}} field must be a list.',
        before: 'The {{field}} field must be a date before {{p0}}.',
        before_or_equal: 'The {{field}} field must be a date before or equal to {{p0}}.',
        between: 'The {{field}} field must be between {{p0}} and {{p1}}.',
        boolean: 'The {{field}} field must be true or false.',
        confirmed: 'The {{field}} confirmation does not match.',
        current_password: 'The password is incorrect.',
        date: 'The {{field}} field is not a valid date.',
        date_equals: 'The {{field}} field must be the date {{p0}}.',
        date_format: 'The {{field}} field does not match the format {{p0}}.',
        decimal: 'The {{field}} field must have {{values}} decimal places.',
        different: 'The {{field}} and {{p0}} fields must be different.',
        digits: 'The {{field}} field must be {{p0}} digits.',
        digits_between: 'The {{field}} field must be between {{p0}} and {{p1}} digits.',
        dimensions: 'The {{field}} image has invalid dimensions.',
        distinct: 'The {{field}} field has a duplicate value.',
        email: 'The {{field}} field must be a valid email address.',
        ends_with: 'The {{field}} field must end with one of: {{values}}.',
        enum: 'The selected {{field}} is invalid.',
        exists: 'The selected {{field}} is invalid.',
        file: 'The {{field}} field must be a file.',
        filled: 'The {{field}} field must have a value.',
        gt: 'The {{field}} field must be greater than {{p0}}.',
        gte: 'The {{field}} field must be greater than or equal to {{p0}}.',
        image: 'The {{field}} field must be an image.',
        in: 'The selected {{field}} is invalid.',
        in_array: 'The {{field}} field does not exist in {{p0}}.',
        integer: 'The {{field}} field must be a whole number.',
        ip: 'The {{field}} field must be a valid IP address.',
        json: 'The {{field}} field must be valid JSON.',
        lowercase: 'The {{field}} field must be lowercase.',
        lt: 'The {{field}} field must be less than {{p0}}.',
        lte: 'The {{field}} field must be less than or equal to {{p0}}.',
        max: 'The {{field}} field exceeds the maximum allowed ({{p0}}).',
        max_digits: 'The {{field}} field must not have more than {{p0}} digits.',
        mimes: 'The {{field}} field must be a file of type: {{values}}.',
        mimetypes: 'The {{field}} field must be a file of type: {{values}}.',
        min: 'The {{field}} field is below the minimum allowed ({{p0}}).',
        min_digits: 'The {{field}} field must have at least {{p0}} digits.',
        multiple_of: 'The {{field}} field must be a multiple of {{p0}}.',
        not_in: 'The selected {{field}} is invalid.',
        not_regex: 'The {{field}} field format is invalid.',
        numeric: 'The {{field}} field must be a number.',
        password: 'The password does not meet the security requirements.',
        present: 'The {{field}} field must be present.',
        prohibited: 'The {{field}} field is not allowed.',
        prohibited_if: 'The {{field}} field is not allowed in this case.',
        prohibited_unless: 'The {{field}} field is not allowed in this case.',
        prohibits: 'The {{field}} field cannot be filled in together with {{values}}.',
        regex: 'The {{field}} field format is invalid.',
        required: 'The {{field}} field is required.',
        required_array_keys: 'The {{field}} field is missing required entries.',
        required_if: 'The {{field}} field is required in this case.',
        required_unless: 'The {{field}} field is required in this case.',
        required_with: 'The {{field}} field is required when {{values}} is present.',
        required_with_all: 'The {{field}} field is required when {{values}} are present.',
        required_without: 'The {{field}} field is required when {{values}} is not present.',
        required_without_all: 'The {{field}} field is required when none of {{values}} are present.',
        same: 'The {{field}} and {{p0}} fields must match.',
        size: 'The {{field}} field must be of size {{p0}}.',
        starts_with: 'The {{field}} field must start with one of: {{values}}.',
        string: 'The {{field}} field must be text.',
        timezone: 'The {{field}} field must be a valid time zone.',
        ulid: 'The {{field}} field must be a valid identifier.',
        unique: 'The {{field}} value is already in use.',
        uploaded: 'The {{field}} file could not be uploaded.',
        uppercase: 'The {{field}} field must be uppercase.',
        url: 'The {{field}} field must be a valid URL.',
        uuid: 'The {{field}} field must be a valid identifier.',

        // Reglas escritas como clase en el backend (app/Rules), en snake_case
        base64_image: 'The {{field}} field must be a base64 png, jpeg, jpg or webp image of up to 4 MB.',
        referral_phone_country: 'The phone number must be from Spain (+34) or France (+33) and have the right number of digits.',
        reclamation_subcategory_belongs_to_category: 'The subcategory does not belong to the selected category.',
        ride_product_description_locales: 'The description only accepts the languages es, en and ca.',
        safe_reclamation_snapshot: 'The {{field}} field is not valid: it is too large, too deeply nested or contains sensitive data.',
        unique_user_document: 'The ID document is not valid or is already linked to another account.',
        valid_phone: 'The phone number format is not valid.',
        valid_user_origin: 'The origin value is not valid or does not exist.',
      },
    },
  },
};
